<template>
  <div>
    <div v-if="loader">
      <div class="spinner"></div>
    </div>
    <!--   Main Content Start Here   -->
    <main>
      <section class="account_wraper">
        <div class="container_large">
          <div class="login_holder">
            <!-- <h4>Welcome Back!</h4> -->
            <!-- <h1>Login to your Account</h1> -->
            <form method="post" @submit.prevent="sendEmail()">
              <div class="form_holder">
                <div class="form_group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    name=""
                    placeholder="Enter your email"
                    required
                    autofocus
                    v-model="forget_email"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors && status && status == 422 && errors['email']"
                  >
                    We can't find a user with that email address.
                  </div>
                </div>
                <!-- <div class="form_group mb-4">
                <input type="submit" value="Reset Password" />
              </div>
              <div class="register_here">
                Already have an account
                <router-link :to="{ name: 'login' }">Login here</router-link>
              </div> -->
                <div class="button_holder">
                  <button type="submit" class="button primary_button">
                    Reset <i class="fi fi-rr-angle-small-right"></i>
                  </button>
                  <!-- <span><router-link :to="{name:'signup'}">Sign Up</router-link></span> -->
                </div>
                <div class="agree_text">
                  Already have an account
                  <router-link :to="{ name: 'login' }">Login here</router-link>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="men_holding_cloths">
          <img
            src="/src/assets/images/girl-with-laundry.png"
            class="img-fluid"
            alt=""
          />
        </div>
      </section>
    </main>
    <!--   Main Content End Here   -->
  </div>
</template>

<script>
import validationErrors from "../../mixins/validationErrors";
import { is422 } from "../../utils/response";
import userApis from "../../Apis/users";
export default {
  mixins: [validationErrors],
  data() {
    return {
      loader: true,
      errors: null,
      status: null,
      forget_email: null,
    };
  },
  methods: {
    async sendEmail() {
      this.loader = true;
      await userApis
        .forgetPasswordEmail({ email: this.forget_email })
        .then((response) => {
          if (response.status == 200) {
            this.$router.push({ name: "login" });
          }
        })
        .catch((error) => {
          this.loader = false;

          if (is422(error)) {
            this.errors = error.response.data.message.errors;
          }
          this.status =
            error.response && error.response.status
              ? error.response.status
              : "";
        })
        .then(() => {
          this.loader = false;
        });
    },
  },
  created() {
    setTimeout(() => {
      this.loader = false;
    }, 1000);
  },
  // computed: {
  //   hasErrors() {
  //     return 422 === this.status && this.errors !== null;
  //   },
  // },
};
</script>


// WEBPACK FOOTER //
// src/components/Auth/forgetPassword.vue